import { Box, Button, Container, Flex, HStack, Menu, MenuButton, MenuItem, MenuList, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { BsChevronDown } from 'react-icons/bs';
import { HiArrowNarrowLeft } from 'react-icons/hi';
import { useNavigate, useParams } from 'react-router-dom';
import UserAdminService from '../../services/admin/admin_users.service';
const UserProfileHistory = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [userHistory, setUserHistory] = useState([]);
    const nameParam = new URLSearchParams(window.location.search).get('name');
    const name = nameParam !== null ? decodeURIComponent(nameParam) : '';
    

    interface IDifference {
        [key: string]: {
            oldValue: any;
            newValue: any;
        };
    }

    useEffect(() => {
        UserAdminService.getUserProfileHistory(params.userid)
            .then((res) => {
                const userHistoryArr = res.data;
                return Promise.all(userHistoryArr.map(async (history: any) => {
                    const newValueObj = JSON.parse(history.new_value);
                    const oldValueObj = JSON.parse(history.old_value);
                    const differingValues:IDifference= {}

                    // Function to recursively find differences in nested objects
                    const findDifferences = (oldValue:any, newValue:any, path = '') => {
                        for (const key in oldValue) {
                            const oldVal = oldValue[key];
                            const newVal = newValue[key];
                            const newPath = path ? `${path}.${key}` : key;
                            
                            if (typeof oldVal === 'object' && typeof newVal === 'object') {
                                findDifferences(oldVal, newVal, newPath); // Recursive call for nested objects
                            } else if (oldVal !== newVal) {
                                differingValues[newPath] = { oldValue: oldVal, newValue: newVal };
                            }
                        }
                    };
    
                    findDifferences(oldValueObj, newValueObj); // Call the function to find differences
    
                    // Log the differing values for each history entry
                    
                    return differingValues;
                }));
            })
            .then((differencesArray: any) => {
                
                // to only include objects that are not empty
                setUserHistory(differencesArray.filter((each:any) => Object.keys(each).length > 0));

            })
            .catch((error) => {
                // Handle errors here
                console.error("Error fetching user profile history:", error);
            });
    }, []);
    


    return (
        <Box minHeight="100vh" pb="30px" bg="#F9F8F8">
            <Container
                width={{ lg: "70%", md: "80%", sm: "95%", base: "95%" }}
                maxWidth={"84%"}
                px={0}
                pt="100px"
                right={0}
                bg="F9F8F8"
                mx="auto"
            >
                <Box
                    mb="60px"
                    display="flex"
                    alignItems="center"
                    border="1px solid #616161"
                    padding={"5px 12px"}
                    width="fit-content"
                    borderRadius="5px"
                    cursor="pointer"
                >
                    <HiArrowNarrowLeft color="#616161" fontSize="20px" />
                    <Text
                        fontSize="14px"
                        color="#616161"
                        pl="5px"
                        onClick={() => navigate(-1)}
                        fontWeight={700}
                    >
                        Go back
                    </Text>
                </Box>
                <Flex
                    bg="white"
                    px="40px"
                    py="40px"
                    boxShadow="md"
                    rounded="lg"
                    height="auto"
                    mb="30px"
                    gap="1rem"
                    direction={"column"}
                >
                    <Text fontWeight={'700'} fontSize={'26px'}>Profile Update History</Text>
                    <HStack justifyContent={"space-between"}>
                        <Text color="#616161" fontSize="16px">{name}</Text>
                        <Menu>
                            <MenuButton
                                as={Button}
                                rightIcon={<BsChevronDown />}
                                bg='white'
                                color='#616161'
                                variant={"outline"}
                                size="sm"
                                fontSize={13}
                                border='1px solid'
                                borderColor='#9E9E9E'
                            >
                                Sort by name(A-Z)
                            </MenuButton>
                            <MenuList fontSize={12}>
                                <MenuItem>2022/2023</MenuItem>
                                <MenuItem>2021/2022</MenuItem>
                                <MenuItem>2020/2021</MenuItem>
                                <MenuItem>2019/2020</MenuItem>
                            </MenuList>
                        </Menu>
                    </HStack>
                    <TableContainer style={{ overflowX: 'auto' }}>
                        <Table variant='simple'>
                            <Thead>
                                <Tr>
                                    <Th>Date and Time</Th>
                                    <Th>Activity</Th>

                                </Tr>
                            </Thead>
                            <Tbody>
                                {
                                    userHistory?.map((history: any, index: number) => {
                                        return (
                                            <Tr key={index}>
                                                <Td>{moment(history?.updated_at.newValue).format("ddd, MMM Do YYYY, h:mm a")}</Td>
                                                <Td>
                                                    {
                                                        Object.entries(history).map(([key,value] , index) => {
                                                            if (key !== "updated_at") {
                                                                const val = value as any
                                                                return <Text as="span" key={index} ><Text as="span" color="#656565" fontWeight={"600"}>{key}</Text> was updated to {val.newValue}, </Text>;
                                                            }
                                                            return null;
                                                        })
                                                    }
                                                </Td>
                                            </Tr>
                                        )
                                    })
                                }
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Flex>
            </Container>
        </Box>
    )
}

export default UserProfileHistory